import React, { useEffect, useState } from 'react';
import './contact.css'; // Custom styles for the Contact component
import AOS from 'aos'; // AOS for animations
import 'aos/dist/aos.css'; // AOS styles
import axios from 'axios';

const Contact = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    debugger
    const jsonFormData = {
      'contact_name': name,
      'contact_email': email,
      'contact_subject': subject,
      'contact_message': message,
      'main_id': "8989877hhftgh67"
    }

    try {
      const response = await axios.post("https://gantasoft.com//gantasoft/postcontactforms.php", jsonFormData, {

      });

      if (response.data == 1) {
        alert("request sent Successfully")
        setName("");
        setEmail("");
        setSubject("");
        setMessage("");
      } else {
        console.error("Error updating Review:", response.data.message);
      }

    } catch (error) {
      console.error("Error updating Review:", error);
    }


    // }
  };

  useEffect(() => {
    AOS.init({ duration: 1000, once: true }); // Initialize AOS animations
  }, []);

  return (
    <section id="contact" className="contact section light-background">
      {/* Section Title */}
      <div className="container section-title" data-aos="fade-up">
        <h2>Contact</h2>
        <p>
          We are here to assist you with any inquiries or concerns you may have.
        </p>
      </div>

      <div className="container" data-aos="fade-up" data-aos-delay="100">
        <div className="row gy-4">
          {/* Contact Info */}
          <div className="col-lg-6">
            <div className="row gy-4">
              {/* Address */}
              <div
                className="col-lg-12"
                data-aos="fade-up"
                data-aos-delay="200"
              >
                <div className="info-item d-flex flex-column justify-content-center align-items-center">
                  <i className="bi bi-geo-alt"></i>
                  <h3>Address</h3>
                  <p>MIG-155,Rd.No 1, KPHB Phase-1,Kukatpally,Hyderabad Telangana, 500072</p>
                </div>
              </div>

              {/* Call Us */}
              <div
                className="col-md-6"
                data-aos="fade-up"
                data-aos-delay="300"
              >
                <div className="info-item d-flex flex-column justify-content-center align-items-center">
                  <i className="bi bi-telephone"></i>
                  <h3>Call Us</h3>
                  <p>+91- 9490370852, +91- 9490241415</p>
                </div>
              </div>

              {/* Email Us */}
              <div
                className="col-md-6"
                data-aos="fade-up"
                data-aos-delay="400"
              >
                <div className="info-item d-flex flex-column justify-content-center align-items-center">
                  <i className="bi bi-envelope"></i>
                  <h3>Email Us</h3>
                  <p>hr@gantasoft.com</p>
                </div>
              </div>
            </div>
          </div>

          {/* Contact Form */}
          <div className="col-lg-6">
            <form
              // action="forms/contact.php"
              // method="post"
              onSubmit={handleSubmit}
              className="php-email-form"
              data-aos="fade-up"
              data-aos-delay="500"
            >
              <div className="row gy-4">
                <div className="col-md-6">
                  <input
                    type="text"
                    name="name"
                    className="form-control"
                    placeholder="Your Name"
                    required
                    value={name}
                    onChange={(e) => { setName(e.target.value) }}
                  />
                </div>
                {/* <div className="col-md-6">
                  <input
                    type="text"
                    className="form-control"
                    name="mobile"
                    placeholder="Your mobile"
                    required
                  />
                </div> */}
                <div className="col-md-6">
                  <input
                    type="email"
                    className="form-control"
                    name="email"
                    placeholder="Your email"
                    required
                    value={email}
                    onChange={(e) => { setEmail(e.target.value) }}
                  />
                </div>
                <div className="col-md-12">
                  <input
                    type="text"
                    className="form-control"
                    name="subject"
                    placeholder="Subject"
                    required
                    value={subject}
                    onChange={(e) => { setSubject(e.target.value) }}
                  />
                </div>
                <div className="col-md-12">
                  <textarea
                    className="form-control"
                    name="message"
                    rows="4"
                    placeholder="Message"
                    required
                    value={message}
                    onChange={(e) => { setMessage(e.target.value) }}
                  ></textarea>
                </div>
                <div className="col-md-12 text-center">
                  <div className="loading">Loading</div>
                  <div className="error-message"></div>
                  <div className="sent-message">
                    Your message has been sent. Thank you!
                  </div>
                  <button type="submit">Send Message</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
